import { TableCell, TableRow } from "../../../design/table";
import { Task } from "../../../models/Task";
import { Checkbox } from "../../../design/checkbox";
import { useState } from "react";
import { useTask } from "../../../contexts/TaskContext";
import { Link } from "../../../design/link";
import { Subheading } from "../../../design/heading";

interface TaskListItemProps {
  task: Task;
}

const TaskListItem: React.FC<TaskListItemProps> = ({ task }) => {
  const { updateTask } = useTask();
  const [isCompleted, setIsCompleted] = useState(task.isCompleted);

  const handleCheckboxChange = (checked: boolean) => {
    setIsCompleted(checked);
    updateTask(task._id, { isCompleted: checked });
  };

  return (
    <TableRow>
      <TableCell style={{ whiteSpace: "pre-line" }}>
        <Link href={`/task/${task._id}`} className="hover:underline">
          <Subheading>{task.title}</Subheading>
        </Link>
      </TableCell>
      <TableCell className="items-center text-right">
        <Checkbox
          checked={isCompleted}
          onChange={handleCheckboxChange}
          className="cursor-pointer"
        />
      </TableCell>
    </TableRow>
  );
};
export default TaskListItem;
